export default "__VITE_ASSET__CxFOgjv1__"